module.exports = __webpack_public_path__ + "7d088296/img/revit-icon.5ff0d581.svg";